/**
 * lucide-react v0.176.0 - ISC
 */

import createLucideIcon from '../createLucideIcon.js';

const ChevronLeft = createLucideIcon("ChevronLeft", [
  ["polyline", { points: "15 18 9 12 15 6", key: "kvxz59" }]
]);

export { ChevronLeft as default };
//# sourceMappingURL=chevron-left.js.map
